import { render, staticRenderFns } from "./CollapseListaDocumentos.vue?vue&type=template&id=00070a5d&scoped=true"
import script from "./CollapseListaDocumentos.vue?vue&type=script&lang=js"
export * from "./CollapseListaDocumentos.vue?vue&type=script&lang=js"
import style0 from "./CollapseListaDocumentos.vue?vue&type=style&index=0&id=00070a5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00070a5d",
  null
  
)

export default component.exports